import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractValidatorEditor } from '../types';
@Injectable({
  providedIn: 'root'
})
export class ValidatorNameService {
  /**
   * å¤çèåæ ¡éªåç§°
   */
  public handleUnionCheckName: (name: string, editor: AbstractValidatorEditor<any>) => Observable<string>;

  constructor() {}
}
